import React from "react"

export default function StickerDefault() {
   return (
      <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M26.4375 8.93295L18.8282 7.82358L15.4271 0.927744C14.8177 -0.301423 13.0521 -0.317048 12.4375 0.927744L9.03648 7.82358L1.42711 8.93295C0.0625248 9.13087 -0.48435 10.8132 0.505233 11.7767L6.01044 17.1413L4.70836 24.7194C4.47398 26.0892 5.91669 27.1152 7.12503 26.4746L13.9323 22.8965L20.7396 26.4746C21.9479 27.11 23.3907 26.0892 23.1563 24.7194L21.8542 17.1413L27.3594 11.7767C28.349 10.8132 27.8021 9.13087 26.4375 8.93295V8.93295ZM19.1719 16.2663L20.4063 23.4746L13.9323 20.0736L7.45836 23.4746L8.69273 16.2663L3.45315 11.1621L10.6927 10.11L13.9323 3.54754L17.1719 10.11L24.4115 11.1621L19.1719 16.2663V16.2663Z" fill="#DEB403" />
      </svg>

   )
}